//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

export const logoutStyles = {
  global: {
    margin: 0,
    padding: 0,
    boxsizing: 'border-box' as const,
  },
  container: {
    display: 'flex',
    height: '100vh',
  },
  container1: {
    display: 'flex',
    height: '100vh',
  },
  leftsection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45%',
    backgroundColor: '#f9f9f9',
    textAlign: 'center' as const,
    padding: '20px',
  },
  rightsection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '55%',
    backgroundColor: '#0066b2',
  },
  content: {
    maxWidth: '500px',
  },
  logoutIcon: {
    marginTop: '-27px',
    width: '400px',
    paddingBottom: '10px',
  },
  heading: {
    fontFamily: 'Inter',
    fontSize: '21px',
    fontWeight: 510 as const,
    lineHeight: '21px',
    textAlign: 'center' as const,
    textUnderlinePosition: 'from-font' as const,
    textDecorationSkipInk: 'none' as const,
  },
  paragraph: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '21px',
    textAlign: 'center' as const,
    textUnderlinePosition: 'from-font' as const,
    textDecorationSkipInk: 'none' as const,
    width: '448px',
  },
  paragraph1: {
    marginBottom: '100px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontStyle: 'bold',
    fontSize: '40px',
    lineHeight: '100%',
    letterSpacing: '0%',
    color: '#474747',
  },
  loginButton: {
    width: '110px',
    height: '40px',
    borderRadius: '4px',
    backgroundColor: '#0066B0',
    fontFamily: 'Inter',
    fontSize: '16px',
    border: 'none',
    color: '#f9f9f9',
    cursor: 'pointer',
    marginTop: '20px',
  },
  loginButtonHover: {
    backgroundColor: '#004a80',
  },
  logo: {
    width: '450px',
  },
};
